import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '../biLogger/BiLogger.context';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import AuthorWatchButton from '../Button/AuthorWatchButton';
import ContentStatistic from '../ContentStatistic';
import { formatDate, DATE_FORMATS } from '../Timestamp/functions';
import DeviationFlags from '../ActionBar/buttons/DeviationFlags';
import s from './SubmissionDetails.scss';
var LONG_TITLE_LENGTH = 28;
var MobileSubmissionDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, author = _b.author, title = _b.title, dailyDeviation = _b.dailyDeviation, isOwner = _a.isOwner, showTitle = _a.showTitle;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    return (React.createElement("div", { className: classnames(s['root'], dailyDeviation && s['with-flag']) },
        dailyDeviation && (React.createElement("div", { className: s['flag'] },
            React.createElement(DeviationFlags, { deviation: deviation }))),
        title && showTitle && (React.createElement("div", { className: classnames(s['title'], title.length > LONG_TITLE_LENGTH && s['long']) }, title)),
        React.createElement("div", { className: s['left'] },
            React.createElement(BiLoggerContextProvider, { value: { sectionname: 'author' } },
                author && (React.createElement(UserAvatar, { withTooltip: true, user: author, className: s['avatar'] })),
                React.createElement("div", { className: s['author-block'] },
                    author && (React.createElement("div", { className: s['author'] },
                        React.createElement("span", { className: s['by'] },
                            t('deviation.details.by'),
                            " "),
                        React.createElement(UserLink, { className: s['username'], usernameClassName: s['username-inner'], withTooltip: true, user: author }),
                        !isOwner && React.createElement(AuthorWatchButton, { author: author }))),
                    (deviation.publishedTime || deviation.isMature) && (React.createElement("div", { className: s['date'] },
                        deviation.publishedTime && (React.createElement(React.Fragment, null,
                            t('deviation.details.published'),
                            ': ',
                            formatDate(deviation.publishedTime, DATE_FORMATS.Date.Full, i18n.language))),
                        deviation.isMature && deviation.publishedTime && (
                        // that is indeed meant to be two spaces each side
                        React.createElement(React.Fragment, null, "\u00A0\u00A0|\u00A0\u00A0")),
                        deviation.isMature && t('deviation.details.mature')))))),
        React.createElement(ContentStatistic, { deviation: deviation })));
};
MobileSubmissionDetails.displayName = 'MobileSubmissionDetails';
export default MobileSubmissionDetails;
//# sourceMappingURL=MobileSubmissionDetails.js.map